export default __webpack_public_path__ + "static/media/close.da5c4222.svg";